module.exports = __webpack_public_path__ + "static/media/loader.1f908b38.svg";